<template>
<!--  <div class="footerAllDiv" :class="{ 'isMobile': ISMOBILE }">-->
  <div class="footerAllDiv">
    <div class="footerAll" :class="{ 'en': $i18n.locale == 'en' }">
      <div class="topSection">
        <div class="leftSide">
          <div class="title">
            <span>{{ $t('footerAll.companyName') }}</span>
            <img src="@/assets/icon/car_icon.png" alt="">
          </div>
          <div class="text">
            <span class="s1">{{ $t('footerAll.text1.i') }}：</span><span>{{ $t('footerAll.text1.Q') }}</span>
          </div>
          <div class="text">
            <span class="s1">{{ $t('footerAll.text2.i') }}：</span><span>{{ $t('footerAll.text2.Q') }}</span>
          </div>
          <div class="text">
            <span class="s1">{{ $t('footerAll.text3.i') }}：</span><span>{{ $t('footerAll.text3.Q') }}</span>
          </div>
          <div class="text">
            <span class="s1">{{ $t('footerAll.text4.i') }}：</span><span class="s2">{{ $t('footerAll.text4.Q') }}</span>
          </div>
        </div>
        <div class="rightSide">
          <div class="lSide">
            <div class="inputBox">
              <el-input class="title" v-model="leaveMsg.name" :placeholder="$t('footerAll.placeholder.n1')"></el-input>
            </div>
            <div class="inputBox">
              <el-input class="email" v-model="leaveMsg.phone" :placeholder="$t('footerAll.placeholder.n2')"></el-input>
            </div>
            <div class="inputBox">
              <el-input class="code" v-model="leaveMsg.email" :placeholder="$t('footerAll.placeholder.n3')"></el-input>
            </div>
          </div>
          <div class="rSide">
            <div class="inputBox">
              <el-input type="textarea" class="content" v-model="leaveMsg.content" :placeholder="$t('footerAll.placeholder.n4')"></el-input>
            </div>
            <div class="btn">{{ $t('footerAll.btn') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomSection">{{ $t('footerAll.declare') }}</div>
  </div>
</template>

<script>
export default {
  name: 'footerAll',
  components: {},
  data () {
    return {
      leaveMsg: {}
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
.footerAllDiv{
  width: 100%;
  background: #333;
  .footerAll {
    width: 1200px;
    background: #333;
    margin: 0 auto;
    padding: 20px 0;
    .topSection {
      display: flex;
      justify-content: space-around;
      .leftSide {
        width: 400px;
        color: #dddddd;
        .title {
          font-size: 22px;
          line-height: 1.2;
          font-weight: bold;
          margin-bottom: 30px;
          span {
            display: inline-block;
            margin-right: 10px;
          }
          img {
            width: 62px;
            vertical-align: middle;
          }
        }
        .text {
          font-size: 14px;
          margin-bottom: 20px;
          span {
            display: inline-block;
            margin-right: 10px;
            //width: 56px;
            //text-align: right;
          }
        }
      }
      .rightSide {
        width: 550px;
        display: flex;
        justify-content: center;
        margin-top: 70px;
        .lSide {
          margin-right: 12px;
          .inputBox {
            width: 235px;
            height: 35px;
          }
          .inputBox:not(last-child) {
            margin-bottom: 12px;
          }
        }
        .rSide {
          .inputBox {
            width: 235px;
            height: 129px;
            .el-textarea__inner {
              height: 133px;
            }
          }
          .btn {
            width: 100px;
            height: 38px;
            line-height: 38px;
            color: #fff;
            background-color: #ff962a;
            text-align: center;
            margin-top: 10px;
            float: right;
          }
        }
      }
    }


  }
  .footerAll.en {
    .topSection {
      .leftSide {
        width: 460px;
        .text {
          .s1 {
            width: 70px;
            text-align: right;
          }
          .s2 {
            width: 490px;
            float: right;
            margin-top: -17px;
            margin-right: -109px;
          }
        }
      }
    }
  }
  .bottomSection {
    width: 100%;
    color: #fff;
    font-size: 14px;
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid rgb(102, 102, 102);
  }
}
.footerAllDiv.isMobile {
  width: 100%;
  .footerAll {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homePage/footerAll.vue